import { PETS_APIS } from "@/api_framework/api_config";
import { ICustomerPetCreationBody, ICustomerPetCreationResponse } from "@/api_framework/api_modals/Pets";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setPetId } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { useRouter } from "../../useRouter";
import { useCustomerPetListAPI } from "./useCustomerPetListAPI";

AxiosCurlirize(axios, () => {});
type CreatePetOptions = {
  fetchAndSetPetDetails: boolean;
  navigateToAppointmentTab?: boolean;
  setPetId?: boolean;
};

// returns new created petId
export const useCustomerPetCreationAPI = () => {
  const configuration = useConfiguration();
  const { getRouteKey } = useRouter();
  const { captureError } = useAPIUtils();
  const [newPetId, setNewPetId] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const fetchPetDetails = useCustomerPetListAPI();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (formData: ICustomerPetCreationBody, options?: CreatePetOptions): Promise<string | null> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
        const requestHeaders = new Headers();
        requestHeaders.append("Authorization", `${accessToken}`);
        const response = await axios
          .post(PETS_APIS?.CREATE_PET?.baseURL ?? "", formData, {
            headers: { Authorization: requestHeaders.get("Authorization") },
          })
          .then((res: AxiosResponse<ICustomerPetCreationResponse>) => {
            dispatch(
              setLoading({
                key: "isPetCreationInProgress",
                status: false,
              }),
            );
            if (res.data.status === true) {
              toast.success(`${formData.pet_name} pet created successfully.`);
              const petId = res.data?.data?.pet_id;
              setNewPetId(petId);
              if (options) {
                if (options?.fetchAndSetPetDetails === true) {
                  fetchPetDetails(formData.user_id, {
                    petId: petId,
                  });
                }
                if (options?.setPetId) {
                  dispatch(
                    setPetId({
                      petId: petId,
                    }),
                  );
                }
                if (options?.navigateToAppointmentTab) {
                  navigate(`${getRouteKey("APPOINTMENTS_TAB", "url")}/${formData?.user_id}/${petId}`);
                }
              }
              return res.data.data.pet_id;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);

            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error");
        return null;
      }
    },
    [],
  );
  return { newPetId, execute };
};
